import React from 'react';
import styles from './styles.module.css';
import BackgroundImage from 'assets/images/aboutus/bg.webp';
import Image from 'next/image';

export const Card = () => {
  return (
    <div className={styles.container}>
      <Image
        src={BackgroundImage}
        alt="About Us"
        width={600}
        height={200}
        className={styles.imageContainer}
        loading="eager"
        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 820px"
      />
      <div className={styles.title}>About RTPCheck.com</div>

      <div className={styles.highlightContainer}>
        <div className={styles.accentBar} />
        <div className={styles.highlightText}>
          Approximately 9 out of 10 online casinos lower the return-to-player
          (RTP) percentage in their games, meaning the chances of winning there
          are significantly reduced.
        </div>
      </div>

      <div className={styles.regularText}>
        We have created the first RTP database for online casino games, with
        most of the data collected by regular users of our site. You have the
        opportunity to check the RTP of any casino—whether you are already
        playing at a casino or considering registering at a new one. Our mission
        is to provide a reliable RTP checking service for players.
      </div>
    </div>
  );
};
